export default function (to, from) {
  if(to?.name === from?.name) return {}
  return {
    x: 0,
    y: 0,
    behavior: 'instant'
  };
}